import type { Place } from "./schema";

const checkedAt = "2026-08-22";

/**
 * 수도권 확장 시드.
 * 운영시간과 요금은 변동 가능성이 커서 카드에는 유형만 저장하고,
 * 방문 직전 공식 사이트에서 최신 회차와 예약 여부를 확인하도록 안내한다.
 */
export const capitalPlaces: Place[] = [
  {
    id: "seoul-childrens-museum",
    name: "서울상상나라",
    category: "museum",
    region: "seoul",
    district: "광진구",
    neighborhood: "능동",
    address: "서울특별시 광진구 능동로 216",
    coordinates: { lat: 37.5495, lng: 127.0867 },
    summary: "놀이 중심의 체험 전시를 층별로 즐길 수 있는 서울 대표 어린이 복합체험시설.",
    dadTip: "서울어린이대공원 안에 있어 공원 산책과 묶기 좋습니다. 시간대별 인원이 제한될 수 있어 예약 가능 여부를 먼저 확인하세요.",
    ageFit: 5,
    rainFriendly: true,
    indoorOutdoor: "indoor",
    priceType: "paid",
    stayTime: "2-4h",
    openDays: ["tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    closedNote: "휴관일과 예약 가능 회차는 공식 사이트 확인",
    phone: "02-6450-9500",
    website: "https://www.seoulchildrensmuseum.org/main.do",
    reservationRequired: true,
    tags: ["서울", "어린이박물관", "체험전시", "실내", "어린이대공원"],
    source: [
      {
        label: "서울상상나라 공식 홈페이지",
        url: "https://www.seoulchildrensmuseum.org/main.do",
        checkedAt,
        status: "official",
        note: "주소와 관람 안내 확인. 방문 전 최신 회차와 예약 현황 재확인 필요",
      },
    ],
  },
  {
    id: "seoul-childrens-grand-park",
    name: "서울어린이대공원",
    category: "park",
    region: "seoul",
    district: "광진구",
    neighborhood: "능동",
    address: "서울특별시 광진구 능동로 216",
    coordinates: { lat: 37.5492, lng: 127.0811 },
    summary: "놀이터와 산책로, 동물·식물 공간을 한 번에 둘러볼 수 있는 서울 도심 가족 공원.",
    dadTip: "공간이 넓어 보고 싶은 시설을 먼저 정하는 편이 좋습니다. 서울상상나라와 같은 날 묶을 때는 아이 체력을 고려하세요.",
    ageFit: 5,
    rainFriendly: false,
    indoorOutdoor: "outdoor",
    priceType: "free",
    stayTime: "half-day",
    openDays: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    website: "https://www.sisul.or.kr/open_content/childrenpark/",
    tags: ["서울", "대형공원", "놀이터", "동물", "산책"],
    source: [
      {
        label: "서울시설공단 서울어린이대공원 안내",
        url: "https://www.sisul.or.kr/open_content/childrenpark/",
        checkedAt,
        status: "official",
        note: "주소 확인. 개별 시설 운영일은 각각 다를 수 있음",
      },
    ],
  },
  {
    id: "gwacheon-national-science-museum",
    name: "국립과천과학관",
    category: "science-creative",
    region: "gyeonggi",
    district: "과천시",
    address: "경기도 과천시 상하벌로 110",
    coordinates: { lat: 37.4381, lng: 127.0057 },
    summary: "자연사·첨단기술·우주 등 다양한 주제의 전시와 체험을 갖춘 수도권 대표 과학관.",
    dadTip: "규모가 커서 아이가 좋아하는 전시관을 2~3개만 우선순위로 정하면 덜 지칩니다. 별도 예약 프로그램도 확인하세요.",
    ageFit: 5,
    rainFriendly: true,
    indoorOutdoor: "mixed",
    priceType: "mixed",
    stayTime: "half-day",
    openDays: ["tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    closedNote: "시설별 운영시간과 휴관일은 공식 사이트 확인",
    phone: "02-3677-1500",
    website: "https://www.sciencecenter.go.kr/",
    tags: ["경기", "과천", "과학관", "체험", "우주", "자연사"],
    source: [
      {
        label: "국립과천과학관 공식 홈페이지",
        url: "https://www.sciencecenter.go.kr/",
        checkedAt,
        status: "official",
        note: "주소와 기본 관람 안내 확인. 전시관별 예약 여부 재확인 필요",
      },
    ],
  },
  {
    id: "gyeonggi-childrens-museum",
    name: "경기도어린이박물관",
    category: "museum",
    region: "gyeonggi",
    district: "용인시",
    neighborhood: "상갈동",
    address: "경기도 용인시 기흥구 상갈로 6",
    coordinates: { lat: 37.2672, lng: 127.1097 },
    summary: "몸과 감각을 사용하는 상설·기획 전시를 중심으로 구성된 어린이 전문 박물관.",
    dadTip: "백남준아트센터와 경기도박물관이 가까워 가족 취향에 따라 한 곳을 더 묶을 수 있습니다. 사전 예약 여부를 확인하세요.",
    ageFit: 5,
    rainFriendly: true,
    indoorOutdoor: "indoor",
    priceType: "mixed",
    stayTime: "2-4h",
    openDays: ["tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    closedNote: "관람 회차와 휴관일은 공식 사이트 확인",
    website: "https://gcm.ggcf.kr/",
    reservationRequired: true,
    tags: ["경기", "용인", "어린이박물관", "체험전시", "실내"],
    source: [
      {
        label: "경기도어린이박물관 공식 홈페이지",
        url: "https://gcm.ggcf.kr/",
        checkedAt,
        status: "official",
        note: "기관 주소와 공식 사이트 확인. 방문 전 최신 회차와 예약 현황 재확인 필요",
      },
    ],
  },
];
